import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import config from 'appconfig';
import { getCurrentMACContactName } from '../duck/selectors';

const GreetingMessage = () => {
  const userName = useSelector(getCurrentMACContactName);

  return (
    <p>
      <FormattedMessage id="mac.top.message.greeting.text" values={{ name: userName }} />
      &nbsp;
      <a href={`${config.wacPurchaseLicensingUrl}#manage-account`}>
        <FormattedMessage
          id="mac.top.message.greeting.link"
          defaultMessage="Learn more about managing your My Atlassian account"
        />
      </a>
    </p>
  );
};
export default GreetingMessage;
